import React, { Fragment } from 'react';
import { Spin } from 'antd';
import './overlay-loader.less';

function OverlayLoaderComponent(
  {
    isVisible = false,
    message = '',
  }
) {
  return (
    <Fragment>
      {
        isVisible && (
          <div className={ `overlay-loader ${ isVisible ? 'show' : '' }` }>
            <Spin tip={ message }/>
          </div>
        )
      }
    </Fragment>
  )
}

export default OverlayLoaderComponent;
